// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--Qo8Zu","image":"a10a3f92e9--image--Ssr5U","title":"a10a3f92e9--title--VPU00","link":"a10a3f92e9--link--h15A8"};